import script from "./DcContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DcContent.vue?vue&type=script&setup=true&lang=js"

import "./DcContent.vue?vue&type=style&index=0&id=96fd1a52&lang=scss"

const __exports__ = script;

export default __exports__